/**
 * 星評価ボタン
 * @module rateStar
*/

export function rateStar() {
	const stars = document.querySelectorAll('#js-star input');
	const starWrappers = document.querySelectorAll('#js-star .wpcf7-list-item');

	if (stars.length) {
		stars.forEach(star => {
			star.addEventListener("change", () => {
				starWrappers.forEach(starWrapper => {
					starWrapper.classList.remove('checked');
				});
				stars.forEach(star => {
					if (star.checked) {
						star.closest('.wpcf7-list-item').classList.add('checked');
					}
				});

			});
		});
	}
}